const part = [
    {
        path: 'warehouse-list',
        name: 'warehouse-list',
        meta: {
            icon: 'ios-medical',
            title: '仓库列表',
            notCache: true,
            access: ['S', 'H'],
            items: [
            ]
        },
        component: () => import('@/view/warehouse-management/warehouse/warehouse-list')
    },
    {
        path: 'warehouseStore',
        name: 'warehouseStore',
        meta: {
            icon: 'ios-medical',
            title: '库存明细',
            notCache: false,
            access: ['S', 'B', 'C', 'H', 'I', 'A', 'G'],
            items: [
            ]
        },
        component: () => import('@/view/warehouse-management/warehouse-store/warehouse-store')
    }
];

export default part;